// extracted by mini-css-extract-plugin
export default {"home":"style_home__7FM0u","home__hero":"style_home__hero__vSgh9","home__hero-text":"style_home__hero-text__puSkq","home__hero-link":"style_home__hero-link__pv-kI"};